export enum WizardType {
  LQS = 'LQS',
  LQSBOX = 'LQSBOX',
  EMH = 'EMH',
}
